/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import withLayout from './withLayout';

const Privacy = () => (
  <div className='grey-section-full'>
    <div className='wrapper small'>
      <div className='div-block'>
        <h1 className='_1st-header'>Privacy Policy</h1>
        <div className='line' />
      </div>
      <p className='paragraph'>
        Entoro&nbsp;Capital, LLC, and any affiliates, (the “Company”) have
        adopted and implemented this privacy policy as part of our commitment to
        protecting your personal information from misuse. We encourage you to
        read this Policy to learn more about the ways we collect, use, disclose,
        and protect the information we gather from this web site. If you are not
        comfortable with any of the practices or policies described in this
        Policy, we ask that you discontinue use of our Site. Please be aware
        that we may periodically update or revise this Policy without notice.
        Accordingly, please check this Policy frequently for changes.
      </p>
      <p className='last'>
        Please note that information gathered in connection with any services
        provided via the Site may be governed by separate terms. In the event
        that you receive such services, you agree that those other terms shall
        supersede any conflicting terms contained in this Policy.
      </p>
      <h2 className='_2nd-header'>Collection of Information (Cookie Policy)</h2>
      <p>
        In order to better serve your particular needs, the Company (and third
        parties working on the Company's behalf) may collect information from
        you while visiting our Site. Some of this information is collected
        automatically through various methods including, but not limited to
        cookies. The Company may also obtain information directly from you and,
        depending upon the nature of transactions you may conduct, from third
        party sources.
      </p>
      <p>
        We may also collect anonymous information, which does not personally
        identify you, when you visit our Site. The anonymous information
        includes the pages you view on our Site, the search terms you enter into
        our search utility, your IP address and the operating system, browser
        software and Internet service provider you use.
      </p>
      <p className='last'>
        We may use the standard "cookie" feature of major browser applications
        and other data capture mechanisms that allow us to store data about your
        visit. Cookies help us learn which areas of our site are useful and
        which areas need improvement. You may configure your browser to prevent
        cookies from being set on your computer. If you do so, you may still
        view most of the Site, although you may not be able to enjoy all of our
        services.
      </p>
      <h2 className='_2nd-header'>Site Users</h2>
      <p className='last'>
        The Site is not intended for children under eighteen (18) years of age.
        The Company does not market any products or services to children under
        eighteen (18) years of age or knowingly collect any information from
        children under eighteen (18) years of age.
      </p>
      <h2 className='_2nd-header'>Third Party Access to Information</h2>
      <p>
        In order to better serve your particular needs, the Company and certain
        companies and individuals working on the Company's behalf will have
        access to all or a portion of the various types of Site visitor
        information we may collect. When we share access to personal information
        with companies or individuals working on the Company's behalf, we
        generally endeavor to protect such personal information by requiring
        those parties to enter into an agreement with the Company to safeguard
        the confidentiality of personal information. We may also disclose
        information about the use of our Site in aggregate, statistical form.
      </p>
      <p className='last'>
        As permitted by law, the information we collect, including personally
        identifiable information, may also be disclosed to third parties if the
        Company, in its sole discretion, believes disclosure is necessary to
        comply with legal or regulatory processes or requests or to protect the
        rights, property, or personal safety of the Company, its affiliates,
        and/or the respective customers, members, directors, officers,
        employees, agents, and representatives of the Company and its
        affiliates; other Site users; and/or the public.
      </p>
      <h2 className='_2nd-header'>Security</h2>
      <p>
        We use a secure server and security protocol to safeguard information we
        collect from you. To help ensure the security of your personal and
        financial information that you submit to us via our Site (other than via
        an e-mail message), we use security software to encrypt the information
        before and during its transmission through the Internet. We allow
        information to be submitted for transmission only if your browser is
        compatible with our security software. If your browser is not
        compatible, you will receive a message indicating your transaction
        cannot be completed because of the security risk.
      </p>
      <p>
        E- mail messages are not secure. Our security software does not encrypt
        e-mail messages. Please keep in mind that transmitting information via
        the Internet is never completely secure and that, therefore, any
        information submitted may be intercepted, viewed, collected, used,
        altered, copied or disclosed by others. We are not responsible for the
        security or confidentiality of communications you send to us (or that we
        send to you) through the Internet using e-mail messages.
      </p>
      <p className='last'>
        We take seriously the issue of safeguarding your privacy online.
        However, please note that you should exercise discretion with respect to
        the submission of any personal or financial information.
      </p>
      <h2 className='_2nd-header'>Links to Other Websites</h2>
      <p className='last'>
        This Site contains links to Web sites of third parties. Please note that
        when you click on one of these links, you will be accessing a website
        the Company does not control and which may be governed by privacy
        policies and practices that differ from ours. The Company is not, and
        will not be, responsible for the privacy policies or practices of third
        parties or the content or security of any third-party Web sites. These
        links are provided solely as a convenience to you and not an endorsement
        by the Company of the contents of such third-party Sites or resources.
        The Company is not, and shall not be held responsible for the legality,
        timeliness, accuracy, completeness or appropriate nature of any
        information, data or other content, advertising, offerings, products, or
        services located on or through any other third-party Sites or resources,
        or any loss suffered by you. If you decide to access a linked Site, you
        do so at your own risk.
      </p>
      <h2 className='_2nd-header'>Consent</h2>
      <p className='last'>
        Any information you submit to us via our online forms or via e-mail is
        provided on a voluntary basis. When you access our Site, the collection,
        use, and distribution of your information will be handled according to
        the terms and policies outlined in this Privacy Policy, unless
        superseded by the appropriate Other Terms (as discussed above). By using
        this Site, you consent to collection and use of your information as
        described in this Policy, including personally identifiable information
        the Company may collect. If you object to any of the policies outlined
        in this Policy, we ask that you do not submit information to the Company
        or access our Site. We may update or modify this Policy at any time. Any
        such updates or modifications will be effective upon posting on this
        Site, and your continued use of the Site will constitute your consent to
        any updated or modified Privacy Policy.
      </p>
      <h2 className='_2nd-header'>Personally Identifiable Information</h2>
      <p className='last'>
        Information We May Collect:&nbsp;We collect certain information directly
        from you, required by regulatory authorities and certain information
        required for performing our services. We do this to help identify you as
        a client, provide our services, and tell you about products or services
        you may want. The information we collect may include: (a) Identity
        information – such as your name, legal entity, Tax ID number, Social
        Security number, address and officers; (b) Information from third
        parties – we may also collect information from consumer reporting
        agencies such as verifying your identity through public records.
      </p>
      <h2 className='_2nd-header'>USA Patriot Act of 2001</h2>
      <p>
        The information that is collected from you is within the guidelines and
        regulations of the USA Patriot Act of 2001, which requires the Company
        to obtain, verify and record information that identifies its clients and
        their affiliates.
      </p>
      <p>
        How We Treat Your Information:&nbsp;While providing 506C Private
        Placements, Acquisition &amp; Divestiture services, as well as other
        offerings and services offered by the Company, we may share certain
        information described above with companies or investors in the ordinary
        course of providing our services. The sharing of this information will
        be subject to the confidentiality and sharing provisions as set forth in
        our engagement letter with you. We may provide information to regulatory
        authorities and law enforcement officials in accordance with applicable
        law or to others when we believe in good faith that the law requires it.
        In the event of a sale of all or part of our business, we may share
        customer information related to that business as part of the
        transaction. We do not sell or share your information with marketers who
        may want to offer you their own products and services. Neither do we
        share information we receive about you from a consumer-reporting agency.
        You do not need to take any action for this benefit.
      </p>
      <p className='last'>
        Securing Your Information: Keeping your information secure is one of our
        most important responsibilities. We maintain physical, electronic and
        procedural safeguards to protect your information. Employees and agents
        are authorized to access your information only when they need it to
        provide you with products and services or to maintain your accounts.
      </p>
      <h2 className='_2nd-header'>Notice of Verification of Client Identity</h2>
      <p className='last'>
        All securities transactions are offered through and settled by Entoro
        Securities, LLC, a member of FINRA/SIPC. As required by Federal law or
        regulation, we must: (a) Obtain a copy of the certificate of
        incorporation, partnership agreement, or other document evidencing the
        establishment of the entity; and (b) Verify that a client, prospective
        client or investor and the principal officers of such client or investor
        do not appear on a list provided to us by the government, such as the
        Treasury Department OFAC “Specifically Designated Nationals and Blocked
        Persons” List (SDN List) and is not from, or engaging in transactions
        with people or entities from, embargoed countries and regions listed on
        the OFAC website.
      </p>
      <h2 className='_2nd-header'>Business Continuity Plan</h2>
      <p>
        In the event of a significant business disruption, either internal or
        external, Entoro Capital, LLC (“the Company”) and its affiliates, plan
        to respond in a timely fashion and resume business operations by
        safeguarding our employees and property, making a financial and
        operational assessment, protecting the firm’s books and records, and
        allowing our customers to transact business. In short, our company’s
        business continuity plan is designed to permit us to resume operations
        as quickly as possible, given the scope and severity of the significant
        business disruption.
      </p>
      <p>
        The business continuity plan addresses:&nbsp;data backup and recovery;
        all mission critical systems; financial and operational assessments;
        alternative communications with customers, employees, and regulators;
        alternate physical location of employees; critical supplier, contractor,
        bank and counter-party impact; regulatory reporting; and assuring our
        customers prompt access to their funds and securities if we are unable
        to continue our business.
      </p>
      <p>
        Significant Business Disruptions:&nbsp;The Company’s plan takes into
        account two kinds of Significant Business Disruptions, internal and
        external. Internal significant business disruptions affect only the
        Company’s ability to communicate and do business, such as a fire or loss
        of electrical power in the office or building. External significant
        business disruptions prevent the operation of the securities markets or
        a number of firms, such as a terrorist attack, a natural disaster, or
        another event that causes a wide-scale, regional disruption in essential
        services.
      </p>
      <p>
        Internal Significant Business Disruptions:&nbsp;In the event of a
        disruption in the Company’s business operations due to an internal
        significant business disruption, the Company will attempt to continue to
        conduct business as usual by utilizing alternative communication methods
        (if available), such as the Internet, cell phones, etc., or by moving
        its operations to an alternative location. If personnel or operations
        must be moved to an alternate location, the Company anticipates that it
        will resume regular operations as soon as possible.
      </p>
      <p>
        External Significant Business Disruptions:&nbsp;In the event of a
        disruption in the Company’s business operations due to an external
        significant business disruption, the Company will attempt to continue to
        conduct business as usual by moving its operations to an alternative
        location outside the affected area, if possible, or by providing
        customers with alternative communication arrangements, as indicated
        below, to conduct business. The Company will attempt to resume business
        within 24 hours and to keep its customers informed regarding relevant
        events to the best of its ability based on the circumstances.
      </p>
      <p>
        In all cases, the Company will resume normal business operations as soon
        as it is able to do so based on the type and the extent of the
        disrupting event.
      </p>
      <p>
        Communications:&nbsp;In the event you are unable to reach the Company at
        our main number, please proceed as follows:
      </p>
      <ol>
        <li className='numbered-list-item'>
          Contact the Company at the following alternate telephone number: (713)
          812-9700
        </li>
        <li className='numbered-list-item'>
          Access the Company’s website at www.offerboard.com.
        </li>
        <li className='numbered-list-item last'>
          The Company offers securities through Entoro Securities, LLC, a member
          of FINRA/SIPC.
          <br />
          Entoro Securities, LLC can be reached at (713)823-2900, or at the
          physical address: 333 West Loop North, Suite 333, Houston, TX 77024.
        </li>
      </ol>
      <p className='paragraph'>
        Contact information:&nbsp;Any questions regarding the Company’s Business
        Continuity Plans should be addressed to:
      </p>
      <p className='paragraph center'>
        {' '}
        James C. Row, <br />
        Entoro Capital, LLC <br />
        333 West Loop North, Suite 333
        <br /> Houston, TX 77024
      </p>
    </div>
  </div>
);

export default withLayout(Privacy);



// WEBPACK FOOTER //
// ./src/components/Privacy.js